import React, { useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import "./CustomerDashboard.css";    
import jsPDF from "jspdf";
import "jspdf-autotable";
import EditProfile from './EditProfile';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from './assets/Logo.png';

function CustomerDashboard() {
  const [user, setUser] = useState(null);
  const [cars, setCars] = useState([]);
  const [pendingServices, setPendingServices] = useState([]);
  const [showHistoryDropdown, setShowHistoryDropdown] = useState(false);
  const [historyFilter, setHistoryFilter] = useState("Whole History"); 
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [showNoHistoryModal, setShowNoHistoryModal] = useState(false);
  const [completedServices, setCompletedServices] = useState([]);
  
  const navigate = useNavigate();

  useEffect(() => {
    console.log("🔄 Updated filteredHistory in React State:", filteredHistory);
  }, [filteredHistory]);

  // دریافت سرویس‌های در انتظار
  const fetchPendingServices = async () => {
    try {
      const response = await fetch(`https://carcure.ca/backend/get-pending-services/${user.Email}`);
      const data = await response.json();
      setPendingServices(data);
    } catch (error) {
      console.error("❌ Error fetching pending services:", error);
    }
  };

  // هدایت به صفحه ویرایش پروفایل
  const handleEditProfile = () => {
    navigate("/edit-profile");
  };

  // حذف سرویس در انتظار
  const handleDeletePendingService = (service) => {
    if (!service) {
      console.error("⚠️ Service is undefined!");
      return;
    }
    if (window.confirm(`🚗 Are you sure to want cancel  ${service.Services}?  `)) {
      fetch("https://carcure.ca/backend/delete-pending-service", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: user.Email,
          brand: service.Brand,
          model: service.Model,
          year: service.Year,
          date: service["Requested Date"],
          time: service["Requested Time"]
        })
      })
      .then(res => res.json())
      .then(data => {
        alert(data.message);
        setPendingServices(prevServices => prevServices.filter(s => 
          !(s.Brand === service.Brand && s.Model === service.Model && s.Year === service.Year &&
            s["Requested Date"] === service["Requested Date"] && s["Requested Time"] === service["Requested Time"])
        ));
      })
      .catch(err => console.error("❌ Error deleting service:", err));
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    console.log("🔍 Retrieved userData from localStorage:", storedUser);
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        console.log("✅ Parsed user:", parsedUser);
      } catch (error) {
        console.error("❌ Error parsing userData:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetch(`https://carcure.ca/backend/get-saved-cars/${user.Email}`)
        .then(res => res.json())
        .then(data => setCars(data))
        .catch(err => console.error("❌ Error fetching cars:", err));

      fetchPendingServices();
    }
  }, [user]);


useEffect(() => {
  if (user) {
    fetch(`https://carcure.ca/backend/get-completed-services/${user.Email}`)
      .then(res => res.json())
      .then(data => setCompletedServices(data))
      .catch(err => console.error("❌ Error fetching completed services:", err));
  }
}, [user]);



const handleRequestService = (selectedCar) => {
  if (pendingServices.length >= 5) {
      alert("❌ You have reached the maximum allowed number of 5 pending service requests. Kindly wait until your existing requests have been processed before submitting a new one.");
      return;
  }
  localStorage.setItem("selectedCar", JSON.stringify(selectedCar));
  navigate("/select-services");
};

  // دریافت تاریخچه سرویس‌ها
  const fetchServiceHistory = async (filter, car) => {
    console.log("🚀 Fetching service history for:", user.Email, car, "Filter:", filter);
    if (!filter || !car) {
      console.error("⚠️ Missing filter or car data!", filter, car);
      return;
    }
    setHistoryFilter(filter);
    try {
      const response = await fetch(`https://carcure.ca/backend/get-service-history/${user.Email}/${car.Brand}/${car.Model}/${car.Year}/${filter}`);
      console.log("📥 Raw response from server:", response);
      const data = await response.json();
      console.log("📂 Received service history (before state update):", data);
      if (data.length === 0) {
        console.warn("⚠️ No service history found!");
        setShowNoHistoryModal(true);
        setFilteredHistory([]);
      } else {
        setShowNoHistoryModal(false);
        setFilteredHistory(data);
      }
    } catch (error) {
      console.error("❌ Error fetching service history:", error);
    }
  };

  const handleCloseHistory = () => {
    setFilteredHistory([]);
    setShowNoHistoryModal(false);
    setShowHistoryDropdown(null);
    setHistoryFilter("");
  };

  const downloadHistoryPDF = () => {
    const doc = new jsPDF();
    doc.text("Service History Report", 14, 10);
    const tableColumn = ["Service Date", "Mileage", "Service Name", "Amount Paid"];
    const tableRows = filteredHistory.map(order => [
      order["Service Date"],
      order.Mileage || "N/A",
      order.Services,
      `$${order["Received Amount"] || 0}`
    ]);
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20
    });
    doc.save("Service_History_Report.pdf");
  };

  const sendEmailReport = async (email) => {
    console.log("📧 Sending email to:", email);
    try {
      const response = await fetch("https://carcure.ca/backend/send-service-history-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
          history: filteredHistory
        }),
      });
      const data = await response.json();
      if (response.ok) {
        alert("✅ Email sent successfully!");
      } else {
        alert("❌ Error sending email: " + data.message);
      }
    } catch (error) {
      console.error("❌ Error sending email:", error);
      alert("Error sending email!");
    }
  };

  const handleDeleteCar = (car) => {
    if (!car) {
      console.error("⚠️ Car is undefined!");
      return;
    }
    if (window.confirm(`🚗 Are you Sure to remove the  ${car.Brand} ${car.Model} (${car.Year})?`)) {
      fetch("https://carcure.ca/backend/delete-car", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: user.Email, brand: car.Brand, model: car.Model, year: car.Year })
      })
      .then(res => res.json())
      .then(data => {
        alert(data.message);
        setCars(cars.filter(c => !(c.Brand === car.Brand && c.Model === car.Model && c.Year === car.Year)));
      })
      .catch(err => console.error("❌ Error deleting car:", err));
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("userData");
    navigate("/login");
  };

  return (
    <>

  
 <div className="Customer-Dashboard-wrapper">

      {/* هدر ثابت در بالای صفحه */}
      <header className="header">
        <img src={logo} alt="Logo" className="header-logo" />
        <div className="header-right">
          <button className="header-button" onClick={handleLogout}>
            <LogoutIcon />
            <span>Logout</span>
          </button>
        </div>
      </header>

      {/* محتوای داشبورد */}
      <div className="dashboard-container">
        <h1>📊 Customer Dashboard</h1>
        {user ? (
          <div className="user-info">
            <p><strong>Name:</strong> {user.Name}</p>
            <p><strong>Email:</strong> {user.Email}</p>
            <p><strong>Phone:</strong> {user.Phone}</p>
            <p><strong>Address:</strong> {user.Address}</p>
            <p><strong>Postal Code:</strong> {user["Postal Code"]}</p>
            <div className="user-buttons">
            <button
 		  className="add-car-button"
 			 onClick={() => {
   				 if (cars.length >= 5) {
    				  alert("Sorry! Each User can add only 5 cars.");
     				 return;
   				 }
   			 navigate("/add-car");
			  }}
			>
    <FaPlus style={{ color:"rgba(42, 250, 5, 0.98)", fontSize: "1.2rem" }} />     Add a New Car
		</button>
                 <button className="add-car-button" onClick={handleEditProfile}>
                     ✏️ Edit Profile
                 </button>
	            {completedServices.length > 0 && (
    		   <button className="review-button" onClick={() => navigate("/review")}>
      		       Leave a Review
    		   </button>
  		)}
            </div>
 	 <hr className="user-buttons-divider" />
             </div>
        ) : <p>Loading user data...</p>}

        <h2>🚗 Your Cars</h2>
        {cars.length > 0 ? (
          <div className="car-list">
            {cars.map((car, index) => (
              <div key={index} className="car-box">
                <strong>{car.Brand} {car.Model} ({car.Year})</strong> - {car.Trim}
                <div className="car-buttons">
                  <button 
                    className="request-service-button" 
                    onClick={() => handleRequestService(car)}
                  >
                    🛠 Request a Service
                  </button>
                  <button
                    className="service-history-button" 
                    onClick={() => setShowHistoryDropdown(prev => (prev === index ? null : index))}
                  >
                    📜 Service History
                  </button>
                  <button
                    className="delete-car-button"
                    onClick={() => handleDeleteCar(car)}
                  >
                    ❌ Delete
                  </button>
                </div>
                {showHistoryDropdown === index && (
                  <div className="history-dropdown">
                    <select onChange={(e) => fetchServiceHistory(e.target.value, car)}>
                      <option value="">Select a Time Range</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 6 Months">Last 6 Months</option>
                      <option value="Last Year">Last Year</option>
                      <option value="Whole History">Whole History</option>
                    </select>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : <p>No cars registered yet.</p>}

        {filteredHistory.length > 0 && (
          <div className="history-modal">
            <h3>📜 Service History</h3>
            <table className="service-history-table">
              <thead>
                <tr>
                  <th>Service Date</th>
                  <th>Mileage</th>
                  <th>Service Name</th>
                  <th>Amount Paid</th>
                </tr>
              </thead>
              <tbody>
                {filteredHistory.map((order, index) => (
                  <tr key={index}>
                    <td>{order["Service Date"]}</td>
                    <td>{order.Mileage || "N/A"}</td>
                    <td>{order.Services}</td>
                    <td>${order["Received Amount"] || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="history-buttons">
              <button onClick={handleCloseHistory}>❌ Close</button>
              <button onClick={downloadHistoryPDF}>📥 Save as PDF</button>
              <button onClick={() => sendEmailReport(user.Email)}>📧 Send to Email</button>
            </div>
          </div>
        )}
        {filteredHistory.length === 0 && showNoHistoryModal && (
          <div className="history-modal">
            <h3>⚠️ No service history found for this car!</h3>
            <button onClick={handleCloseHistory}>❌ Close</button>
          </div>
        )}
<hr />
        <h2>🛠 Pending Service Requests: </h2>
        {pendingServices.length > 0 ? (
          <ul>
            {pendingServices.map((service, index) => (
              <li key={index}>

               <strong>{service.Brand} {service.Model} ({service.Year})</strong> {}
	      <br /><strong>Schaduled Date and Time:</strong> {service["Requested Date"]} at {service["Requested Time"]}

                <br /><strong>Services:</strong> {service.Services}
                <br /><strong>Total Price:</strong> ${service["Total Price"]}
                <br />
                <button 
                  className="cancel-service-button" 
                  onClick={() => handleDeletePendingService(service)}
                >
                  ❌ Cancel Service
                </button>
		<hr />
              </li>
            ))}
          </ul>
        ) : <p>No pending service requests.</p>}
      </div>
</div>
    </>
  );
}

export default CustomerDashboard;
